var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@shoelace-style/shoelace/dist/components/divider/divider.js";
let WhSeparatorElement = class WhSeparatorElement extends LitElement {
    constructor() {
        super(...arguments);
        this.orientation = "horizontal";
    }
    isVertical() {
        return this.orientation === "vertical";
    }
    render() {
        return html `<sl-divider
      ?vertical=${this.isVertical()}
      class=${this.orientation}
    >
    </sl-divider>`;
    }
};
/* Stryker disable next-line StringLiteral */
WhSeparatorElement.styles = css `
    :host {
      display: block;
      height: 1rem;
    }
  `;
__decorate([
    property({ type: String })
], WhSeparatorElement.prototype, "orientation", void 0);
WhSeparatorElement = __decorate([
    customElement("wh-separator")
], WhSeparatorElement);
export { WhSeparatorElement };
